import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogButton } from '@beeinventor/dasiot-react-component-lib';
import { capitalize, styled } from '@mui/material';
import { CustomContentProps, useSnackbar } from 'notistack';

import DasLockSvgIcon from '../../assets/SvgIcon/alert/DaslockAlertSvgIcon';

interface UnlockRequestNotificationProps extends CustomContentProps {
  key: string;
  project: {
    id: string;
    name: string;
  };
  equipmentName?: string;
  dasId: string;
}

const Root = styled('div')`
  background-color: #e5e5e5;
  min-width: 400px;
  max-width: 600px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

  & > .operation {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
    gap: 8px;
  }

  .cancel-button {
    color: ${({ theme }) => theme.color.primary.$100};
    background-color: #fff;
    &:hover {
      color: black;
      opacity: 0.3;
      background-color: transparent;
    }
  }
`;

const Title = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  & > svg {
    width: 40px;
    height: 40px;
  }
  .bold {
    flex-shrink: 0;
    font-weight: bold;
  }
`;

const UnlockRequestNotification = React.forwardRef<
  HTMLDivElement,
  UnlockRequestNotificationProps
>((props, ref) => {
  const { project, equipmentName, dasId, id } = props;
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();
  const navigate = useNavigate();

  return (
    <Root ref={ref} key={id}>
      <Title>
        <DasLockSvgIcon />
        <div>
          <Trans
            i18nKey="accountJson.page.notification-list.requested-unlock-descriiption"
            values={{
              equipmentName: equipmentName ?? t('unknown'),
              dasId,
            }}
          >
            <span>Received a request to unlock</span>
            <span className="bold">equipmentName (dasId)</span>
          </Trans>
        </div>
      </Title>
      <div className="operation">
        <DialogButton
          color="primary"
          variant="contained"
          onClick={() => {
            closeSnackbar(id);
            navigate(`/account/project/${project.id}/notification-list`);
          }}
        >
          {t('view')}
        </DialogButton>
        <DialogButton
          variant="contained"
          className="cancel-button"
          onClick={() => closeSnackbar(id)}
        >
          {capitalize(t('close'))}
        </DialogButton>
      </div>
    </Root>
  );
});

UnlockRequestNotification.displayName = 'UnlockRequestNotification';

export default UnlockRequestNotification;
